export default __webpack_public_path__ + "static/media/The_Nest_large_7.137e95e4.jpg";